<template>
  <div class="content contentA">
    <div class="content-left">
      <div class="content-left-1">
       <el-dropdown trigger="click" style="cursor: pointer;" @command="chooseType">
          <span class="el-dropdown-link" style="font-size: 16px">{{typeName || '全部'}}<i class="el-icon-caret-bottom"></i></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) in  typeData" :key="index" :command="[item.type, item.name]">{{item.name}}</el-dropdown-item>
          </el-dropdown-menu>
       </el-dropdown>
       <div v-if="flag == 2" class="el-icon-edit-outline" @click="add"></div>
      </div>
      <div class="content-left-2">
        <el-input size="mini" v-model="label" @input="getTree" placeholder="请输入关键字" clearable></el-input>
        <el-tree ref="tree" :data="treeData" :props="defaultProps" style="margin-top: 10px;color: #8E8E8E;font-size: 14px;height: 68vh" 
        node-key="id" :default-checked-keys="defaultCheckedKeys" :default-expanded-keys="defaultExpandedKeys"
        @node-click="handleNodeClick">
          <!-- <span slot-scope="{ node, data }">
            <span v-if="!data.children" class="el-icon-document"></span>
            <span v-else-if="node.expanded" class="el-icon-folder-opened"></span>
            <span v-else class="el-icon-folder"></span>
            <span style="margin-left: 0.5vw;" :title='node.name || "-"'>{{node.name}}</span>
          </span> -->
        </el-tree>
      </div>
    </div>
    <div class="content-right">
      <div class="content-left-1">
        <p style="font-size:16px">安全生产责任制</p>
        <div>
          <el-input size="medium" v-model="description" placeholder="请输入关键字" style="height: 32px"></el-input>
          <span class="button3" style="margin: 0 8px 0 10px" @click="select">查询</span>
          <span class="button3" @click="add2" v-if="flag == 2">添加</span>
        </div>
      </div>
      <div class="content-right-2">
        <el-table
         :header-cell-style="{color:'#909399',fontFamily: 'SourceHanSansCN-Regular',fontSize:'14px',fontWeight: 'normal'}"
         :data="tableData" stripe height="67vh" @selection-change="handleSelectionChange" :row-key="(row) => { return row.id }"
        ref="table" @select="selectTable">
          <el-table-column type="selection" :reserve-selection="true" width="55" v-if="flag == 1"></el-table-column>
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <span>{{scope.row.index}}</span>
            </template>
          </el-table-column>
          <el-table-column label="隐患级别">
            <template slot-scope="scope">
              <span v-if="scope.row.level == 1">一级隐患</span>
              <span v-else-if="scope.row.level == 2">较大隐患</span>
              <span v-else-if="scope.row.level == 3">重大隐患</span>
            </template>
          </el-table-column>
            <el-table-column label="检查事项">
            <template slot-scope="scope">
              <span>{{scope.row.description}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" v-if="flag == 2">
            <template slot-scope="scope">
                <span class="table-button" @click="handleDel(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="flag == 1">
          <!-- <el-pagination
            v-if="flag == 2"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="1"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="20"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination> -->
          <div>
            <span class="button2" @click="ddd">取消</span>
            <span class="button2" style="background: #4D6EB1;color: #fff;margin-left: 32px;" @click="handleUpdate">确定</span>
          </div>
          <!-- <el-button v-if="flag == 1" @click="submitFun">提交</el-button> -->
        </div>
      </div>
      
    </div>

    <!-- 弹出框 -->
    <el-dialog
      class="dialog"
      :visible.sync="addDialog"
      width="600px"
      center>
      <p slot="title" class="dialog-title">新建标准</p>
       <el-form  label-position="right" label-width="180px">
        <el-form-item label="所属项：">
          <el-cascader
            :options="treeData"
            :props="props"
            @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item label="类型：">
          <el-select v-model="addForm.type">
            <el-option label="质量检查" value="quality_check"></el-option>
            <el-option label="安全检查" value="safe_check"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称：">
          <el-input v-model="addForm.label" size="medium" placeholder="请输入名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm1" style="background-color: #4D6EB1">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 添加条文弹出框 -->
    <el-dialog
      class="dialog"
      :visible.sync="addDialog2"
      width="600px"
      center>
      <p slot="title" class="dialog-title">添加条文</p>
       <el-form  label-position="right" label-width="180px">
        <el-form-item label="所属项：">
          <!-- <el-select size="medium" placeholder="请选择">

          </el-select> -->
          <el-cascader
            :options="treeData"
            :props="props"
            @change="handleChange2"></el-cascader>
        </el-form-item>
        <el-form-item label="标准详情：">
          <el-input v-model="addForm2.description" size="medium"  type="textarea" :autosize="{ minRows: 5}" placeholder="请输入内容" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="隐患级别：">
          <el-select v-model="addForm2.level">
            <el-option label="一级隐患" :value="1"></el-option>
            <el-option label="较大隐患" :value="2"></el-option>
            <el-option label="重大隐患" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addDialog2 = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm2" style="background-color: #4D6EB1">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    props: ['flag', 'panId', 'obj', 'edit'],
    data() {
      return {
        // flag: 2,    // 1 添加进来的   2  tab切换
        value: '',
        description2: '',
        checkedData: [],
        safeId: '',
        defaultCheckedKeys: [],
        defaultExpandedKeys: [],
        typeName: '',
        type2: '',   // 树形结构上面的类型

        pageSize: 1000,
        pageNum: 1,
        total: 0,
        treeData: [],
        id: '',
        tableData: [],

        name: '',
        typeData: [
          {
            name: '全部',
            value: '',
            type: ''
          },
          {
          name: '安全检查',
          value: 2,
          type: 'safe_check'
        },{
          name: '质量检查',
          value: 1,
          type: 'quality_check'
        }],
        defaultProps: {
          children: 'sysSafeLists',
          label: 'label',
        },
        props: {
          children: 'sysSafeLists',
          label: 'label',
          value: 'id',
          checkStrictly: true
        },
        addDialog: false,
        addDialog2: false,
        groupId: '',
        types: [],
        strPerson: [],
        priority: '',
        handleStr: '',

        picUrls: '',//问题图片
        description: '',  // 问题描述
        type: '',

        apprStr: '',
        bimId: '',
        bimHouse:[
          {id:'1',label:'1栋',value:'1'},{id:'2',label:'2栋',value:'2'},{id:'3',label:'3栋',value:'3'},{id:'4',label:'4栋',value:'4'},
          {id:'5',label:'5栋',value:'5'},{id:'6',label:'6栋',value:'6'},{id:'7',label:'7栋',value:'7'},{id:'8',label:'8栋',value:'8'},
          {id:'9',label:'9栋',value:'9'},{id:'10',label:'10栋',value:'10'},{id:'11',label:'11栋',value:'11'},{id:'12',label:'12栋',value:'12'},
          {id:'13',label:'13栋',value:'13'},
        ],
        uploadphotoUrl: base.url + '/upload/uploadPhoto', //上传地址
        uploadHead: {
          accessToken: util.session.get('token'),
        },
        uploadphotoData: {
          type: '203',
        },
        fileList: [],
        label: '',
        addForm: {
          type: '',
          label: '',
          parentId: 0
        },
        addForm2: {
          description: '',
          parentId: 0,
          level: ''
        },
      };
    },
    mounted() {
      this.defaultCheckedKeys.push(this.obj.safeId)
      if(this.obj.safeId){
        this.defaultExpandedKeys.push(this.obj.safeId)
        this.id = this.obj.safeId
        this.getTableData2()
      }

      this.groupId = util.session.get('groupId')
      this.name = this.typeData[0].name
      this.type = this.typeData[0].value
      this.getDictByType()
      this.getPerson()
      this.getTreeList()
    },
    methods: {
      ddd(){
        this.$emit('ddd')
      },
      chooseType(value){
        this.type2 = value[0]
        this.typeName = value[1]
        this.getTreeList()
      },

      handleSizeChange(val) {
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getTableData()
      },

      // 提交
      handleUpdate(){
        myHttp.updateProQsPlanPageNew({
          id: this.panId,
          safeItem: this.description2,
          safeItemId: this.safeId,
          safeId: this.id
        }).then(resp => {
          if(resp.data.code === 200){
            this.$message.success('提交成功！！')
            this.ddd()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

      //  获取树形结构
      getTreeList(){
        myHttp.getListByEntity({
          label: this.label,
          type: this.type2,
          parentId: 0,
          id: ''
        }).then(resp => {
          if(resp.data.code === 200){
            this.treeData = resp.data.data.user
            if(this.obj.safeId){
              setTimeout( () => {
                this.$refs.tree.setCurrentKey(this.obj.safeId)
              }, 100)
            }
          }else{
            this.$message.error(reps.data.msg)
          }
        })
      },

      // 删除
      handleDel(row){
         this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            myHttp.deleteInfoNews({
              id: row.id,
            }).then(resp => {
              if(resp.data.code === 200){
                this.$message.success('删除成功！！')
                this.getTableData()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
      },

      selectTable(selection, row){
        if(this.checkedData.length > 0){
          this.$refs.table.toggleRowSelection(row, false)
        }
      },

      handleSelectionChange(data){
        this.checkedData = data
        if(data.length > 1){
          this.$message.warning('只能选中一个！！')
          return
        }
        this.safeId = data[0].id
        this.description2 = data[0].description
      },

      handleChange(val){
        if(val.length == 0){
          this.addForm.parentId = 0
        }else{
          this.addForm.parentId = val[val.length - 1]
        }
      },
      handleChange2(val){
        if(val.length == 0){
          this.addForm2.parentId = 0
        }else{
          this.addForm2.parentId = val[val.length - 1]
        }
      },

      submitForm1(){
         myHttp.createInfoNews(this.addForm).then(resp => {
          if(resp.data.code === 200){
            this.$message.success('添加成功！！')
            this.addDialog = false
            this.getTreeList()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

     submitForm2(){
       myHttp.createInfoNewPage(this.addForm2).then(resp => {
          if(resp.data.code === 200){
            this.$message.success('添加成功！！')
            this.addDialog2 = false
            this.getTreeList()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
     },

      handleNodeClick(data){
        this.id = data.id
        this.getTableData()
      },

      select(){
        this.getTableData()
      },

      getTableData(){
        myHttp.getListByEntityList({
          parentId: this.id,
          description: this.description,
          pageSize: this.pageSize,
          pageNum: this.pageNum
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            const data = resp.data.data.data.list
            for(let i=0;i<data.length;i++){
              data[i].index = (this.pageNum - 1)*this.pageSize + 1 + i
            }
            this.tableData = data
            this.total = resp.data.data.data.total
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

      getTableData2(){
        myHttp.getListByEntityList({
          parentId: this.id,
          description: this.description,
          pageSize: this.pageSize,
          pageNum: this.pageNum
        }).then(resp => {
          if(resp.data.code === 200){
            const data = resp.data.data.data.list
            for(let i=0;i<data.length;i++){
              data[i].index = (this.pageNum - 1)*this.pageSize + 1 + i
            }
            this.tableData = data
            this.total = resp.data.data.data.total
            for(let i=0; i<data.length;i++){
              if(this.obj.safeItemId == data[i].id){
                this.$refs.table.toggleRowSelection(data[i])
              }
            }
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

      submitFun() {
        var that = this
        var picUrls = []
        var that = this
        for (var i = 0; i < this.fileList.length; i++) {
          picUrls.push(this.fileList[i].response.data.saveUrls)
        }
        this.picUrls = picUrls.toString()
        var form = {
          form:1,
          projectId: this.groupId,
          type: this.type,
          priority: this.priority, //问题性质
          // happenDate: this.data.date, //发生时间
          description: this.description, //问题描述
          picUrls: this.picUrls, //问题图片
          handleStr: this.handleStr, //责任人id
          apprStr: this.apprStr, //确认人id
          reportBy: util.session.get("user").id, //发起人
          qsItemId: this.qsItemId,
          planId: this.planId,
          bimId:this.bimId,
          checkType: this.checkType
        }
        // if (!form.picUrls) {
        //   this.$message.error('请上传照片')
        //   return
        // }
        // if (!form.priority) {
        //   this.$message.error('请选择问题性质')
        //   return
        // }
        // if (!form.handleStr) {
        //   this.$message.error('请选择责任人')
        //   return
        // }
        myHttp
          .createInfoQs(form)
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('提交成功')
              that.$router.go(-1);
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },


      getTree(){
        this.getTreeList()
      },
    
      changeType(value){
        for(let i=0;i<this.typeData.length;i++){
          if(value == this.typeData[i].type){
            this.type = this.typeData[i].value
            this.name = this.typeData[i].name
          }
        }
        this.getTreeList()
      },

      handleIconSuccess(res, file, opt, other) {
        if (res.code == '200') {
          this.fileList = opt
        } else {
          this.$message.error(res.msg)
        }
      },

      // 获取问题列表
      getDictByType() {
        // getDictByType
        var that = this
        myHttp
          .getDictByType({
            type: 'qs_priority'
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.types = resp.data.data.dictList
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      // 获取责任人列表
      getPerson() {
        var that = this;
        myHttp
          .getRoleUserList({
            groupId: this.groupId,
            userType: util.session.get('roleId')
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.strPerson = resp.data.data.users
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      add(){
        // this.addForm.label = ''
        // this.addDialog = true
        util.session.set('typeSS',2)
        this.$router.push({
          path:'/newPatrolLibrarySet'
        })
      },
      add2(){
        this.addForm2.description = ''
        this.addForm2.level = ''
        this.addDialog2 = true
      }
    },
  }
</script>

<style scoped>
.button{
  display: inline-block;
  width: 50px;
  height: 24px;
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 24px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  cursor: pointer;
  box-sizing: border-box;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.el-input{
  width: 224px;
}
.el-input--mini .el-input__inner{
  height: 32px;
  line-height: 32px;
}
.content{
  height: 100%;
  /* padding: 1vh 1vw; */
  display: flex;
  flex-direction: row;
}
.content-left{
  width: 256px;
  height: 100%;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  margin-right: 16px;
}
.content-left-1{
  display: flex;
  height: 52px;
  justify-content: space-between;
  padding: 16px;
  align-items: center;
  border-bottom: 2px solid #E7E7E7;
}
.content-left-2{
  overflow: auto;
  padding: 8px 16px;
}
.content-right{
  flex: 1;
  border-radius: 6px;
  background: #FFFFFF;
  padding-bottom: 2vh;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  height: 100%;
  overflow: auto;
}
.pagination{
  height: 50px;
  padding: 10px 0;
  border-radius: 0px 0px 6px 6px;
  background: #FFFFFF;
  box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
}
.el-pagination{
  padding: 1vh!important;
}
.content-right-3{
  padding: 1vh 1vw;
}
.content-right-4{
  padding: 1vh 1vw;
  display: flex;
  flex-wrap: wrap;
}
.content-right-4 > p{
  margin-bottom: 2vh;
}
.el-button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.dialog-title{
  height: 48px;
  padding-left: 24px;
  text-align: left;
  background: #ECF0F5;
  font-size: 16px;
  color: #666;
  border-radius: 6px 6px 0px 0px;
  line-height: 48px;
}
.content >>> .el-dialog__header{
  padding: 0;
}
.content >>> .el-dialog{
  border-radius: 6px;
}
.dialog >>> .el-form-item__label{
  font-family: 'SourceHanSansCN-Regular';
  font-size: 18px;
  color: #9E9E9E;
}
.dialog >>> .el-input__inner{
  width: 300px;
}
.dialog >>> .el-textarea__inner{
  width: 300px;
}
.dialog >>> .el-form-item__content{
  width: 300px;
}
.button2{
  display: inline-block;
  width: 55px;
  height: 28px;
  border-radius: 2px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid #999999;
  box-sizing: border-box;
  line-height: 28px;
}
.button3{
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid #999999;
  font-size: 14px;
  color: #666;
  line-height: 32px;
  cursor: pointer;
}
.button3:hover{
  background: #4D6EB1;
  color: #fff;
}
.table-button{
  display: inline-block;
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: rgba(227, 233, 246, 0.05);
  box-sizing: border-box;
  border: 1px solid rgba(236, 15, 15, 0.8);
  font-size: 14px;
  color: #F57979;
  line-height: 24px;
  cursor: pointer;
}
.contentA{
  padding: 0 !important;
}
::v-deep .cell>span{
    font-size: 14px !important;
  }
  ::v-deep .cell{
    font-size: 14px !important;
  }
  .el-icon-edit-outline:hover{
    cursor: pointer;
    opacity: 0.6;
  }
</style>